<template>
  <el-dialog :visible.sync="visible" width="850px" :show-close="true" :before-close="handleClose" class="follow-dialog">
    <div class="title">
      <img src="@/assets/persion.png" alt="" />
      <p>我的关注({{ total }})</p>
    </div>

    <div class="content-dialog" v-loading="loading">
      <div v-if="followList.length === 0 && !loading" class="empty-img">
        <img class="empty" src="@/assets/listempty.png" alt="" />
      </div>

      <div v-else class="content-inner">
        <div
          v-for="(item, index) in followList"
          :key="item.employeeId || item.userId"
          class="options"
          :class="{'options-last': index + 1 !== followList.length}"
        >
          <div class="name" @click="handleSearchByUser(item)">
            <img v-if="item.headPicUrl" :src="item.headPicUrl" :alt="item.nickName" @error="handleAvatarError" />
            <p>{{ item.nickName || '未设置昵称' }}</p>
            <img  class="sex" :src="item.gender === 1 ? boyimg : girlimg" alt="" />
          </div>
          <p class="action" @click="handleUnfollow(item, index)" :class="{loading: item.unfollowing}">
            {{ item.unfollowing ? '取消中...' : '取消关注' }}
          </p>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {getFollowedListApi, unfollowApi} from '../../api/counsult'

export default {
  name: 'FollowListDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    employeeId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      followList: [],
      total: 0,
      defaultAvatar: '/img/default-avatar.png',
      businessType: '咨询',
      boyimg: require('@/assets/boy.png'),
      girlimg: require('@/assets/girl.png')
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.fetchFollowList()
      }
    }
  },
  methods: {
    // 获取关注列表
    async fetchFollowList() {
      this.loading = true
      try {
        const res = await getFollowedListApi({businessType: this.businessType, employeeId: this.employeeId})
        if (res.code === 200) {
          this.followList = res.data.followEmployeeVos || []
          this.total = res.data.total || 0
        } else {
          if (res.msg) {
            this.$message.error(res.msg)
          }
        }
      } catch (error) {
        // this.$message.error('获取关注列表失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },

    // 取消关注
    async handleUnfollow(item, index) {
      try {
        await this.$confirm('确定要取消关注吗？', '确认取消关注', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        // 设置取消关注状态
        this.$set(item, 'unfollowing', true)

        const res = await unfollowApi({
          objectType: '咨询',
          objectId: item.employeeId
        })

        if (res.code === 200) {
          this.$message.success('取消关注成功')
          // 从列表中移除
          this.followList.splice(index, 1)
          this.total = Math.max(0, this.total - 1)
          // 触发父组件刷新数据
          this.$emit('unfollowSuccess')
          this.fetchFollowList()
        } else {
          this.$message.error(res.msg || '取消关注失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('取消关注失败:', error)
          this.$message.error('取消关注失败，请稍后重试')
        }
      } finally {
        this.$set(item, 'unfollowing', false)
      }
    },

    // 获取性别样式类
    getGenderClass(gender) {
      return gender === 1 ? 'male' : 'female'
    },

    // 获取性别文本
    getGenderText(gender) {
      return gender === 1 ? '♂' : '♀'
    },

    // 处理头像加载错误
    handleAvatarError(event) {
      event.target.src = this.defaultAvatar
    },

    // 点击用户名称
    handleSearchByUser() {
      // 可以在这里添加点击用户名称的逻辑，比如跳转到用户详情页
      // this.$emit('searchByUser', item)
    },

    // 关闭弹窗
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.follow-dialog {
  /deep/ .el-dialog__header {
    padding: 0 !important;
  }
  /deep/ .el-dialog__body {
    padding: 20px 0 50px 0;
  }
  /deep/ .el-dialog {
    border-radius: 10px;
    height: auto;
    // max-height: 70vh;
    overflow: auto;
  }
}

.title {
  padding-left: 20px;
  margin-bottom: 31px;
  img {
    width: 31px;
    height: 30px;
    margin-top: 2px;
    margin-right: 10px;
    display: inline-block;
    font-size: 0;
  }
  p {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 33px;
    display: inline-block;
    vertical-align: top;
  }
}

.content-dialog {
  height: 371px;
  // overflow: hidden;
}
.content-inner {
  height: 370px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.options {
  width: 80%;
  margin: 0 auto 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0 30px 0;
  .name {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    cursor: pointer;
    img {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      margin-right: 12px;
    }
    p {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 48px;
    }
    .sex {
      position: absolute;
      top: -5px;
      left: 38px;
      width: 21px;
      height: 21px;
    }
  }
}

.options-last {
  border-bottom: 1px solid #e9e9e9;
}

.empty-img {
  margin: 0 auto;
  overflow: hidden;
}

.empty {
  width: 400px;
  display: block;
  margin: 80px auto;
}

.action {
  background: #5ad3cd;
  display: inline-block;
  line-height: 1;
  cursor: pointer;
  color: #fff;
  text-align: center;
  box-sizing: border-box;
  font-weight: 500;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
  transition: all 0.3s;

  &:hover {
    opacity: 0.9;
  }

  &.loading {
    opacity: 0.6;
    cursor: not-allowed;
  }
}
</style>
